import ProgressBar from "../ui/ProgressBar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import React from "react";
import AdminOpInputs from "./AdminOpInputs";
import useAdminOperation from "../hooks/useAdminOperation";
const createEmptyContext = () => ({
  albumId: null,
  artistId: null,
  trackId: null,
  input: "",
  userIds: [],
});
function AdminOpCard({ op, runOp, idle }) {
  const [context, setContext] = React.useState(() => createEmptyContext());
  const [resetToken, setResetToken] = React.useState(0);
  const resetInputs = React.useCallback(() => {
    setContext(createEmptyContext());
    setResetToken((prev) => prev + 1);
  }, []);
  const { running, status, progress, runOperation, cancelOperation } =
    useAdminOperation(op, idle, runOp, {
      onReset: resetInputs,
    });
  const handleRun = React.useCallback(() => {
    runOperation(context);
  }, [context, runOperation]);
  const handleCancel = React.useCallback(
    (e) => {
      e?.stopPropagation();
      cancelOperation();
    },
    [cancelOperation],
  );
  const buttonLabel = running
    ? progress.known
      ? `${progress.current}/${progress.total}`
      : status?.status === "stopping"
        ? "Stopping…"
        : op.runningLabel || "Running"
    : "▶ Run";
  const progressValue = progress.known ? progress.percent / 100 : 0;
  return (
    <div className="admin-card">
      <div className="details">
        <h3>
          <span className="icon">{op.icon}</span> {op.title}
        </h3>
        <p>{op.description}</p>
        <AdminOpInputs
          op={op}
          onContextChange={setContext}
          resetToken={resetToken}
        />
        {status && !status.error && status.message && (
          <div className="status">{status.message}</div>
        )}
        {running && status?.last_album && (
          <div className="status">Last album: {status.last_album}</div>
        )}
        {status && status.error && (
          <Alert className="status" role="alert" severity="error">
            Error: {status.error}
          </Alert>
        )}
      </div>
      <div className="action">
        <Button
          className={`btn run${running ? " running" : ""}${op.poll === false ? " no-poll" : ""}${op.cancellable ? " cancellable" : ""}`}
          onClick={handleRun}
          disabled={
            running && (!op.cancellable || status?.status === "stopping")
          }
        >
          <span className="label">{buttonLabel}</span>
          {running && op.cancellable && (
            <ProgressBar
              onClick={handleCancel}
              title="Cancel job"
              value={progressValue}
              label="Job progress"
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
              }}
            />
          )}
        </Button>
        {running && op.cancellable && (
          <Button
            type="button"
            className="btn stop mobile-stop-btn"
            color="error"
            onClick={handleCancel}
            disabled={status?.status === "stopping"}
          >
            Stop
          </Button>
        )}
      </div>
    </div>
  );
}
export default AdminOpCard;
